module.exports = __webpack_public_path__ + "img/产品.d4708746.png";